import { Component, Input, isDevMode, output, inject } from '@angular/core';
import { DefaultWidgetsService } from '@app/shared/services/default-widgets.service';
import { AbstractControl } from '@angular/forms';
import { SchemaFormModule } from 'ngx-schema-form';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'inspekt-preview-panel',
    templateUrl: './preview-panel.component.html',
    styleUrls: ['./preview-panel.component.scss'],
    imports: [SchemaFormModule, CommonModule]
})
export class PreviewPanelComponent {
    private defaultWidgetsService = inject(DefaultWidgetsService);

    public isDevMode = isDevMode();
    public schemaData = '';
    public displaySchema: any;
    public originalSchema: any;

    readonly schemaChangeEvent = output<string>();

    private _schema: AbstractControl;

    @Input() public set schema(value: AbstractControl) {
        if (!value) {
            return;
        }
        this._schema = value;

        if (typeof value === 'string') {
            this.displaySchema = JSON.parse(value);
            setTimeout(() => {
                this.originalSchema = JSON.parse(
                    JSON.stringify(this.displaySchema)
                );
            });
        } else {
            this.displaySchema = JSON.parse(this.schema?.value);
        }
    }
    public get schema(): AbstractControl {
        return this._schema;
    }

    public get schemaChanged(): boolean {
        return (
            JSON.stringify(this.displaySchema) !==
            JSON.stringify(this.originalSchema)
        );
    }

    drop(ev) {
        ev.preventDefault();
        this.editWidget(this.getWidgetName(ev));
    }

    allowDrop(ev) {
        ev.preventDefault();
    }

    editWidget(categoryName) {
        const newSchemaObj = JSON.parse(
            this.schema.value == null ? this.schema : this.schema.value
        );
        const newWidget =
            this.defaultWidgetsService.getWidgetByName(categoryName);
        const firstProp =
            newSchemaObj.properties[Object.keys(newSchemaObj.properties)[0]]
                .properties;
        firstProp[newWidget.name] = newWidget.defaultJson;
        this.displaySchema = newSchemaObj;
        this.schema.setValue(JSON.stringify(this.displaySchema, null, 2));
        this.schema.markAsDirty();
    }

    public schemaDataChangeHandler(value) {
        this.schemaData = value;
    }

    private getWidgetName(ev) {
        return ev.dataTransfer.getData('widget');
    }
}
